import ResetPasswordForm from 'features/auth/components/organisms/ResetPasswordForm/ResetPasswordForm';

export default ResetPasswordForm;
